import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/SimulPage.css'
import { FaArrowLeft } from 'react-icons/fa'
import useRgbToHex from '../hooks/useRgbToHex'
import useHexToRgb from '../hooks/useHexToRgb'

const SimulPage = ({simulatedColor, color, blindType}) => {

  let textColor = [255, 255, 255]
  color = useHexToRgb(color)
  if (Number(color[0]) > 200 && Number(color[1]) > 200 && Number(color[2]) > 200) {
    textColor = [0, 0, 0]
  }
  const concatSimulatedColor = useRgbToHex(simulatedColor)
  textColor = useRgbToHex(textColor)
  color = useRgbToHex(color)
  
  return (
    <div className='simulPage-div'>
      <nav className='back-arrow-nav'>
        <Link to="/">
          <FaArrowLeft className='back-arrow'/>
        </Link>
      </nav>
      <main className='main-show-diff-color'>
        <h3>{blindType}</h3>
        <div className='diff-color'>
          <div className='display-div display1' style={{backgroundColor: color, color: textColor}}>
            <p>BEFORE</p>
            <p>{color.toUpperCase()}</p>
          </div>
          <div className='display-div display2' style={{backgroundColor: concatSimulatedColor, color: textColor}}>
            <p>AFTER</p>
            <p>{concatSimulatedColor}</p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default SimulPage